new ScrollHint(".js-scrollable", {
  suggestiveShadow: true,
  // remainingTime: 5000,
  i18n: {
    scrollable: "スクロールできます",
  },
});

// mobile-nav__linkがクリックされたときの処理
document.addEventListener("click", function (event) {
  // クリックされた要素がmobile-nav__linkクラスを持っているかを確認
  if (event.target.classList.contains("mobile-nav__link")) {
    // mobile-menu-drawerというIDを持つ要素を取得
    var mobileMenuDrawer = document.getElementById("mobile-menu-drawer");

    // mobile-menu-drawerが存在し、open属性を持っている場合
    if (mobileMenuDrawer && mobileMenuDrawer.hasAttribute("open")) {
      // open属性を削除
      mobileMenuDrawer.removeAttribute("open");
    }
  }
});

// アカウントページのクーポンコード表示
const observer = new MutationObserver((mutations, obs) => {
  const span = document.querySelector(".socialplus-association-status");
  if (span && span.textContent.trim() === "連携済") {
    console.log("Element found, modifying DOM.");
    var htmlContent = `
      <div class="coupon-wrapper">
        <h2 class="title">300円オフクーポン</h2>
        <p class="text">お支払い画面でクーポンコード<br>【POMULU-R300】を入力してご使用ください。</p>
        <p class="comment">※クーポンは一度のみご使用いただけます。</p>
        <div class="coupon-banner">
          <img src="https://cdn.shopify.com/s/files/1/0745/2662/1984/files/02_card_300yen_coupon_1540x1000px_c916bed4-ab8e-4ade-a670-3d04bfcfa4d0.jpg?v=1735208026" width="770px" height="500px" alt="SPECIAL COUPON ￥300OFF">
        </div>
      </div>
    `;
    span.insertAdjacentHTML("afterend", htmlContent);
    obs.disconnect(); // 監視を終了
  }
});

// 監視の設定
observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// ヘッダーの購入ボタン表示
function getCartAndSearchClass() {
  if (window.innerWidth <= 768) {
    return ".header__wrapper .header__secondary-links .header__icon-wrapper, header__icon-list"; // モバイル用のクラス名
  } else {
    return ".header__wrapper .header__icon-list"; // デスクトップ用のクラス名
  }
}

document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded and parsed");

  function handleScrollEvent() {
    console.log("Scroll event triggered");

    var scrollPosition = window.scrollY;
    var cartAndSearchClass = getCartAndSearchClass();
    var cartAndSearch = document.querySelectorAll(cartAndSearchClass);
    var customButton = document.getElementById("custom-button");

    // 要素が存在するか確認
    if (cartAndSearch.length > 0 && customButton) {
      console.log("Elements found:", {
        cartAndSearch: cartAndSearch.length,
        customButton: !!customButton,
      });

      // スクロール位置が100ピクセルを超えたら切り替える
      if (scrollPosition > 100) {
        cartAndSearch.forEach((element) => (element.style.display = "none"));
        customButton.style.display = "block";
      } else {
        cartAndSearch.forEach((element) => (element.style.display = "flex"));
        customButton.style.display = "none";
      }
    } else {
      console.log("Element not found:", {
        cartAndSearch: cartAndSearch.length,
        customButton: !!customButton,
      });
    }
  }

  // スクロールイベントリスナーを追加
  window.addEventListener("scroll", handleScrollEvent);

  // 画面サイズが変更されたときにクラス名を更新
  window.addEventListener("resize", handleScrollEvent);

  // 初回読み込み時にもクラス名を設定
  handleScrollEvent();

  // ページによって遷移先を変更
  window.navigateToCustomPage = function () {
    var currentPage = window.location.pathname;
    var targetUrl = "";

    // ページごとに遷移先を設定
    if (currentPage.includes("collection")) {
      targetUrl = "/products/2way-hipseat";
    } else if (currentPage.includes("product")) {
      targetUrl = "/products/2way-hipseat";
    } else {
      targetUrl = "/products/2way-hipseat";
    }

    window.location.href = targetUrl;
  };
});

// トップページ読み込みが完了したときにABOUTのビデオ再生
window.addEventListener("DOMContentLoaded", function () {
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.bottom > 0 &&
      rect.right > 0
    );
  }

  function playVideos() {
    const videoWrappers = document.getElementsByClassName(
      "video-wrapper--native"
    );
    for (let i = 0; i < videoWrappers.length; i++) {
      const videoWrapper = videoWrappers[i];
      // 表示されている要素のみをチェック
      if (window.getComputedStyle(videoWrapper).display !== "none") {
        const video = videoWrapper.querySelector("video");
        if (isInViewport(videoWrapper)) {
          if (video && video.paused) {
            video.play();
          }
        } else {
          if (video && !video.paused) {
            video.pause();
          }
        }
      }
    }
  }

  window.addEventListener("scroll", playVideos, false);
  window.addEventListener("resize", playVideos, false);

  // Initial check in case the video is already in view on page load
  playVideos();
});

/*  slick スライダー
  ---------------------------------------------------*/

function checkBreakPoint() {
  w = $(window).width();
  if (w <= 749) {
    // スマホ向け（749px以下のとき）
    $(".shopify-section--blog-posts .article-list")
      .not(".slick-initialized")
      .slick({
        infinite: false, // 無限スライド
        variableWidth: true,
        slidesPerView: 1,
        touchThreshold: 15,
        respondTo: "slider",
        prevArrow:
          '<div class="slide-arrow prev-arrow"><span class="arrow"></span></div>',
        nextArrow:
          '<div class="slide-arrow next-arrow"><span class="arrow"></span></div>',
      });
  } else {
    // PC向け
    $(".shopify-section--blog-posts .article-list.slick-initialized").slick(
      "unslick"
    );
  }
}
// ウインドウがリサイズする度にチェック
$(window).resize(function () {
  checkBreakPoint();
});
// 初回チェック
checkBreakPoint();

/*  スライダー 　商品
---------------------------------------------------*/
// $(window).on("load resize", function () {
//   var w = $(window).width();
//   if (w <= 749) {
//     const container = document.querySelector(".section-variation .inner");
//     const boxContainer = document.querySelector(".variation-list");
//     const leftArrow = document.querySelector(".Arrow.left");
//     const rightArrow = document.querySelector(".Arrow.right");

//     // scrollAmountを動的に計算する関数
//     function getScrollAmount() {
//       return container.offsetWidth * 0.6; // コンテナ幅の40%をスクロール量に設定、必要に応じて調整
//     }

//     leftArrow.addEventListener("click", () => {
//       const containerWidth = container.offsetWidth;
//       const maxScrollAmount = boxContainer.offsetWidth - containerWidth;
//       const currentScrollAmount =
//         Math.abs(parseInt(boxContainer.style.transform.split("(")[1])) || 0;
//       const newScrollAmount = Math.max(
//         currentScrollAmount - getScrollAmount(),
//         0
//       );
//       boxContainer.style.transform = `translateX(-${newScrollAmount}px)`;
//       updateArrowVisibility(newScrollAmount, maxScrollAmount);
//     });

//     rightArrow.addEventListener("click", () => {
//       const containerWidth = container.offsetWidth;
//       const maxScrollAmount = boxContainer.offsetWidth - containerWidth;
//       const currentScrollAmount =
//         Math.abs(parseInt(boxContainer.style.transform.split("(")[1])) || 0;
//       const newScrollAmount = Math.min(
//         currentScrollAmount + getScrollAmount(),
//         maxScrollAmount
//       );
//       boxContainer.style.transform = `translateX(-${newScrollAmount}px)`;
//       updateArrowVisibility(newScrollAmount, maxScrollAmount);
//     });
//   }
// });

document.querySelectorAll(".button.button--primary").forEach((element) => {
  if (element.classList.length === 2) {
    // 2つのクラスのみを持つ場合
    element.classList.add("exact-match");
  }
});

/*  スライダー 　商品
---------------------------------------------------*/
const swiperSlides = document.getElementsByClassName("swiper-slide");
const breakPoint = 500; // ブレークポイントを設定
let swiper;
let swiperBool;

window.addEventListener(
  "load",
  () => {
    if (breakPoint < window.innerWidth) {
      swiperBool = false;
    } else {
      createSwiper();
      swiperBool = true;
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    if (breakPoint < window.innerWidth && swiperBool) {
      swiper.destroy(false, true);
      swiperBool = false;
    } else if (breakPoint >= window.innerWidth && !swiperBool) {
      createSwiper();
      swiperBool = true;
    }
  },
  false
);
const createSwiper = () => {
  swiper = new Swiper(".swiper", {
    slidesPerView: "auto",
    spaceBetween: 56,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
};

/*  アコーディオン
---------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  const hash = window.location.hash.substring(1);
  if (hash) {
    const detailsElement = document.getElementById(hash);
    if (detailsElement) {
      detailsElement.setAttribute("open", "");
    }
  }
});

$(function () {
  btn_topscroll();
  smooth_scroll(); 
});

/*  トップスクロールボタン　表示切り替え
---------------------------------------------------*/
function btn_topscroll() {
  var top_scroll = $(".btn-topscroll");
  top_scroll.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 350) {
      top_scroll.stop(true, true).fadeIn();
    } else {
      top_scroll.stop(true, true).fadeOut();
    }
  });
  $("body").on("touchmove", function () {
    if ($(this).scrollTop() > 350) {
      top_scroll.stop(true, true).fadeIn();
    } else {
      top_scroll.stop(true, true).fadeOut();
    }
  });
}

  /*  スムーススクロール
---------------------------------------------------*/
function smooth_scroll() {
  $(window).on("load resize", function () {
    var w = $(window).width();
    if (w >= 1024) {
      $('a[href^="#"]').click(function () {
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        var position = target.offset().top - "80";
        if (href == "#") {
          position = target.offset().top;
        }
        $("html, body").stop().animate(
          {
            scrollTop: position,
          },
          speed,
          "swing"
        );
        return false;
      });
    } else {
      $('a[href^="#"]').click(function () {
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        var position = target.offset().top - "80";
        if (href == "#") {
          position = target.offset().top;
        }
        $("html, body").stop().animate(
          {
            scrollTop: position,
          },
          speed,
          "swing"
        );
        return false;
      });
    }
  });
}

  /*  レビューをもっと見る
---------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("button-review-more");
  const summary = document.querySelector(".review-summary");

  button.addEventListener("click", function () {
    summary.classList.add("expanded");
    button.remove(); // 押した後ボタンを消すならこれ（任意）
  });
});

  /*  バナー非表示
---------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  const closeBtn = document.querySelector("#btn-close-banner");
  const banner = document.querySelector(".banner-container");

  if (closeBtn && banner) {
    closeBtn.addEventListener("click", function () {
      // フェードアウトクラスを追加
      banner.classList.add("is-hidden");

      // 完全に非表示にする場合（アニメ後）
      setTimeout(function () {
        banner.style.display = "none";
      }, 400); // transitionと同じ時間にする
    });
  }
});